import { ImageWMS } from 'ol/source';
import {Group, Image as ImageLayer} from 'ol/layer';

const urlEstadistica=import.meta.env.VITE_GEOSERVER_URL;

//layers censo 2010
const layersDiscapacidadCensoDep2010=[
    {title:'Discapacidad auditiva (% personas por fraccion censal)',layer:'discapacidad_auditiva_censo_2010'},
    {title:'Discapacidad mentental (% personas por fraccion censal)',layer:'discapacidad_mental_censo_2010'},
    {title:'Discapacidad miembros inferiores (% personas por fraccion censal)',layer:'discapacidad_miembros_inferiores_censo_2010'},
    {title:'Discapacidad miembros inferiores (% personas por fraccion censal)',layer:'discapacidad_miembros_superiores_censo_2010'},
    {title:'Discapacidad total (% personas por fraccion censal)',layer:'discapacidad_total_censo_2010'},
    {title:'Discapacidad visual (% personas por fraccion censal)',layer:'discapacidad_visual_censo_2010'},
]

const imageLayersDiscapacidadCensoDep2010 = layersDiscapacidadCensoDep2010.map(({ title, layer }) => new ImageLayer({
    title,
    visible: false,
    source: new ImageWMS({
        url: `${urlEstadistica}/censo2010/wms`,
        params: { 'LAYERS': layer,grupo:'censo2010' },
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    }),
}));

//layers censo 2010
const layersNbiCensoDep2010=[
    {title:'NBI - Tucumán - Vivienda (% hogares por fracción censal)',layer:'nbi_tuc_vivienda_censo_2010'},
    {title:'Tucumán - Hacinamiento (% hogares por fracción censal)',layer:'nbi_tuc_hacinamiento_censo_2010'},
    {title:'Tucumán - Condiciones sanitarias (% hogares por fracción censal)',layer:'nbi_tuc_condiciones_sanitarias_censo_2010'},
    {title:'Tucumán - Capacidad de subsistencia (% hogares por fracción censal)',layer:'nbi_tuc_capacidad_subsistencia_censo_2010'},
    {title:'Tucumán - Asistencia escolar (% hogares por fracción censal)',layer:'nbi_tuc_asistencia_escolar_censo_2010'},
    {title:'Tucumán - Al menos un NBI (% hogares por fracción censal)',layer:'nbi_tuc_almenos_uno_censo_2010'},
    {title:'Gran SMT - Vivienda (% hogares por radio censal)',layer:'nbi_gsmt_vivienda_censo_2010'},
    {title:'Gran SMT - Hacinamiento (% hogares por radio censal)',layer:'nbi_gsmt_hacinamiento_censo_2010'},
    {title:'Gran SMT - Condiciones sanitarias (% hogares por radio censal)',layer:'nbi_gsmt_condiciones_sanitarias_censo_2010'},
    {title:'Gran SMT - Capacidad de subsistencia (% hogares por radio censal)',layer:'nbi_gsmt_capacidad_subsistencia_censo_2010'},
    {title:'Gran SMT - Asistencia escolar (% hogares por radio censal)',layer:'nbi_gsmt_asistencia_escolar_censo_2010'},
    {title:'Gran SMT - Al menos un NBI (% hogares por radio censal)',layer:'nbi_gsmt_almenos_uno_censo_2010'}
]

const imageLayersNbiCensoDep2010 = layersNbiCensoDep2010.map(({ title, layer }) => new ImageLayer({
    title,
    visible: false,
    source: new ImageWMS({
        url: `${urlEstadistica}/censo2010/wms`,
        params: { 'LAYERS': layer,grupo:'censo2010' },
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    }),
}));

//layers censo 2010
const layersPrivacionConvergenteCensoDep2010=[
    {title:'Privación Convergente (% de Personas por Radio Censal - GSMT)',layer:'gsmt_ipmh_por_radio_porcentaje_personas_censo_2010'},
    {title:'Privación Convergente (% de hogares por radio censal 2010)',layer:'tuc_ipmh_por_radio_censo_2010'},
    {title:'Privación Convergente (% de Personas por Radio Censal - Provincia de Tucumán) ',layer:'tuc_ipmh_por_radio_porcentaje_personas_censo_2010'}
]

const imageLayersPrivacionConvergenteCensoDep2010= layersPrivacionConvergenteCensoDep2010.map(({title,layer})=>new ImageLayer({
    title,
    visible: false,
    source: new ImageWMS({
        url: `${urlEstadistica}/censo2010/wms`,
        params: { 'LAYERS': layer,grupo:'censo2010' },
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))

//layers censo 2010
const layersResultadosGeneralesCensoDep2010=[
    {title:'Población por localidad',layer:'tuc_poblacion_por_localidad_censo_2010'},
    {title:'Hogares con vivienda propia por departamento (%)',layer:'tuc_vivienda_propia_censo2010'},
    {title:'Variación intercensal de la población 2001-2010 por departamento (%)',layer:'tuc_variacion_intercensal_poblacion_censo_2010'},
    {title:'Población de comunas y municipios',layer:'tuc_poblacion_por_comunas_municipios_censo_2010'},
    {title:'Densidad poblacional por departamento (habitantes/km2)',layer:'tuc_densidad_poblacional_censo_2010'},
    {title:'Analfabetismo por departamento (%)',layer:'tuc_analfabetismo_por_departamento_censo_2010'}
]

const imageLayersResultadosGeneralesCensoDep2010=layersResultadosGeneralesCensoDep2010.map(({title,layer})=>new ImageLayer({
    title,
    visible: false,
    source: new ImageWMS({
        url: `${urlEstadistica}/censo2010/wms`,
        params: { 'LAYERS': layer,grupo:'censo2010'},
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))

export const censo2010=new Group({
    title:'Censo 2010',
    fold:'close',
    layers:[
        new Group({
            title:'Resultados generales',
            fold: 'close',
            layers: imageLayersResultadosGeneralesCensoDep2010
        }),
        new Group({
            title:'Discapacidad',
            fold:'close',
            layers:imageLayersDiscapacidadCensoDep2010
        }),
        new Group({
            title:'Necesidades Básicas Insatisfechas',
            fold: 'close',
            layers: imageLayersNbiCensoDep2010
        }),
        new Group({
            title:'Estimador Provincial del Índice de Privación Material',
            fold:'close',
            layers:imageLayersPrivacionConvergenteCensoDep2010
        })
    ]
})
